<template>
	<div style="width:1200px; height:800px;" v-on:keyup.esc="close()">
		<div class="view_inner">
			<div class="fixed-table-container">
				<div class="table-wrapper" style="width: 100%; height:670px; overflow-x: auto; overflow-y: auto;">
					<table v-if="display_list.length && po_sh_list.length" id="item_list" class="list_tbl" :style="{ width: 'calc(' + po_sh_list.length * 10 + '% + 200px)' }">
						<colgroup>
							<col width="200px" />
							<col v-for="index in po_sh_list.length" :key="index" :width="'calc((100% - 200px) / ' + po_sh_list.length + ')'" />
						</colgroup>
						<thead>
							<tr class="all_border">
								<th rowspan="2">Item</th>
								<th v-if="sh_cnt > 0" :colspan="sh_cnt">Shipped</th>
								<th v-if="po_cnt > 0" :colspan="po_cnt">Non-Shipped</th>
							</tr>
							<tr class="all_border">
								<th v-for="po_sh in po_sh_list" :key="po_sh.no" :class="{ background_lightyellow: po_sh.no === 'PO' + po_no }">{{ po_sh.dn }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="display in display_list" :key="display.item_id">
								<td>{{ display.item_code }}</td>
								<td v-for="po_sh in po_sh_list" :key="display.item_id + '/' + po_sh.no" class="al_right" :class="{ background_lightyellow: po_sh.no === 'PO' + po_no }">{{ display[po_sh.no] | commaSeparated }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="view_bottom_bt">
				<a href="javascript:;" type="button" class="gray_bt mgr_10" @click="excel()">Excel</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="close()">Close</a>
			</div>
		</div>
	</div>
</template>

<script>
import { apiPrevPurchaseShipmentGroupByItemMaster } from '@/api/report/report.js';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
export default {
	data: () => ({
		po_sh_list: [],
		display_list: [],
	}),
	props: {
		po_no: Number,
	},
	computed: {
		sh_cnt() {
			return this.po_sh_list ? this.po_sh_list.filter(el => el.type === 'SH').length : 0;
		},
		po_cnt() {
			return this.po_sh_list ? this.po_sh_list.length - this.sh_cnt : 0;
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		excel() {
			if (!this.display_list || !this.display_list.length) {
				this.$toast.error('No Data to Export.');
				return;
			}
			const headerGroups = [
				{ key: 'item', name: '' },
				{ key: 'PO', name: 'Non-Shipped' },
				{ key: 'SH', name: 'Shipped' },
			];
			const headers = [{ key: 'item_code', groupKey: 'item', name: 'Item Code', width: 25, dataType: defaultDataType.string }];
			this.po_sh_list.forEach(el => {
				headers.push({ key: el.no, groupKey: el.type, name: el.dn, width: 15, dataType: defaultDataType.currency });
			});

			exportDataExcel(this.display_list, headers, 'PrevPurchaseShipment', headerGroups);
		},
		async prevPurchaseShipmentGroupByItemMaster() {
			let { data } = await apiPrevPurchaseShipmentGroupByItemMaster(this.po_no);

			const po_sh_list = [];
			const display_list = [];
			const item_list = data.item_list;
			const item_po_list = data.item_po_list || [];
			const item_sh_list = data.item_sh_list || [];

			data.sh_list.forEach(el => po_sh_list.push({ type: 'SH', no: 'SH' + el.sh_no, dn: el.sh_dn }));
			po_sh_list.push({ type: 'PO', no: 'PO' + data.ori_po_no, dn: data.ori_po_dn }); // origin P/O와 other P/O를 구분하지 않기로..
			data.po_list.forEach(el => {
				// Origin P/O가 P/O 중 가장 먼저 나올 수 있도록 작업
				if (this.po_no !== el.po_no) po_sh_list.push({ type: 'PO', no: 'PO' + el.po_no, dn: el.po_dn });
			});

			item_list.forEach(it => {
				const obj = { item_id: it.item_id, item_code: it.item_code };

				po_sh_list.forEach(ps => {
					let quantity = null;
					let idx = -1;
					if (ps.type === 'PO') {
						idx = item_po_list.findIndex(ip => ip.item_id === it.item_id && 'PO' + ip.po_no === ps.no);
						if (idx > -1) quantity = item_po_list[idx].remain_quantity;
						// else if (ps.no === 'PO' + this.po_no) quantity = it.quantity; // item_po_list에 origin P/O 정보도 포함..
					} else if (ps.type === 'SH') {
						idx = item_sh_list.findIndex(is => is.item_id === it.item_id && 'SH' + is.sh_no === ps.no);
						if (idx > -1) quantity = item_sh_list[idx].sh_quantity;
					}

					obj[ps.no] = quantity;
				});

				display_list.push(obj);
			});

			this.po_sh_list = po_sh_list;
			this.display_list = display_list;
		},
	},
	created() {
		this.prevPurchaseShipmentGroupByItemMaster();
	},
};
</script>

<style scoped>
.all_border th {
	border: 2px solid #c9c9c9;
}
.all_border :first-child {
	border-left: none;
}
.all_border :last-child {
	border-right: none;
}
.background_lightyellow {
	background: lightyellow;
}
</style>
